import React from 'react';
import { connect } from 'react-redux';
import { INTERACTION_MODE } from 'pxc-editor-material-svg-rendering/constants';
import { getAllLayers } from 'pxc-editor-core/helpers/schema';
import {
  setImageInSection,
  updateSelectedSectionsProp,
  updateSelectedSectionsProps,
  addCustomSectionBorderColor,
} from '@/actions';
import InsertImageTab from './InsertImage';

const SideMenuComponent = (props) => <InsertImageTab {...props} />;

const mapStateToProps = state => ({
  mode: state.core.mode,
  pages: state.core.pages,
  sectionsSelection: state.core.sectionsSelection,
  shieldsSelection: state.core.shieldsSelection,
  customSectionBorderColors: state.core.customSectionBorderColors,
  userSizeUnit: state.core.userSizeUnit,
  isMultiColored: state.core.isMultiColored,
  paperColor: state.core.paperColor,
  ribbonColor: state.core.ribbonColor,
});

const mapDispatchToProps = dispatch => ({
  setImageInSection: image => dispatch(setImageInSection(image, true)),
  updateSelectedSectionsProp: (changedProp, value) => dispatch(updateSelectedSectionsProp(changedProp, value, true)),
  updateSelectedSectionsProps: (changedProp, value) => dispatch(updateSelectedSectionsProps(changedProp, value)),
  addCustomSectionBorderColor: color => dispatch(addCustomSectionBorderColor(color)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  const {
    mode,
    sectionsSelection,
    pages,
    shieldsSelection,
    customSectionBorderColors,
    userSizeUnit,
    isMultiColored,
    paperColor,
    ribbonColor,
  } = stateProps;
  const { verticalAlignment, horizontalAlignment } = ownProps?.props;
  const {
    updateSelectedSectionsProp,
    updateSelectedSectionsProps,
    addCustomSectionBorderColor,
    setImageInSection,
  } = dispatchProps;
  let selectedSection = null;
  let imageName = null;
  let maxWidth = 0;

  if (shieldsSelection && Object.keys(shieldsSelection).length) {
    for (const shId in shieldsSelection) {
      const selShield = shieldsSelection[shId];
      maxWidth = maxWidth < selShield.primitiveProps.w? selShield.primitiveProps.w : maxWidth;
      maxWidth = maxWidth < selShield.primitiveProps.h? selShield.primitiveProps.h : maxWidth;
    }
  } else if (sectionsSelection && Object.keys(sectionsSelection).length) {
    for (const secId in sectionsSelection) {
      const { section } = getAllLayers(secId, pages);
      maxWidth = maxWidth < section.w? section.w : maxWidth;
      maxWidth = maxWidth < section.h? section.h : maxWidth;
    }
  }
  //absolute maximum of image side length
  const ppmm = 8;
  maxWidth = maxWidth * ppmm < 1000? maxWidth * ppmm : 1000;
  
  switch (mode) {
    case INTERACTION_MODE.EDIT: {
      for (const secId in sectionsSelection) {
        const { section } = getAllLayers(secId, pages);
        selectedSection = section;
        break;
      }
      if (selectedSection) {
        if (selectedSection.image) {
          imageName = selectedSection.image.name;
        }
      }
      break;
    }
    default: {
      break;
    }
  }

  return {
    selectedSection,
    commonProps: {
      updateSelectedSectionsProp,
      updateSelectedSectionsProps,
      addCustomSectionBorderColor,
      customSectionBorderColors,
      setImageInSection,
    },
    sectionFormatProps: {
      imageName,
      userSizeUnit,
      isMultiColored,
      colorsList: [ paperColor, ribbonColor ],
    },
    horizontalAlignment: horizontalAlignment,
    verticalAlignment: verticalAlignment,
    maxWidth: maxWidth
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(SideMenuComponent);
